// extracted by mini-css-extract-plugin
module.exports = {"button":"apple-pay-button_button__U1_R6"};